import { MongooseError } from 'mongoose';

export class DuplicateKeyError extends MongooseError {
  constructor() {
    super('Duplicate key error');
  }
}
